import * as API from "@/services/API";
import { RecordIdentifier } from "@/data/global";
import { CourseProduct } from "@/data/products";
import { Course } from "@/data/course";

interface CourseProductCreationParameter {
    region_id: RecordIdentifier,
    course_id: RecordIdentifier,
    price: number,
    course: Course,
}

export default {
    getCourse(courseId: RecordIdentifier) {
        return API.apiClient.get(`/course/${courseId}`);
    },
    getCourseForRegistration(courseId: RecordIdentifier) {
        return API.apiClient.get(`/course/${courseId}?usage=register`);
    },
    getCourseAppointments(courseId: RecordIdentifier) {
        return API.apiClient.get(`/course/${courseId}/appointments`);
    },
    getUserCourseAppointments(courseId: RecordIdentifier) {
        return API.apiClient.get(`/user/course/${courseId}/appointments`);
    },
    getUserCourseEnrollments() {
        return API.apiClient.get(`/user/course/enrollment`);
    },
    getCourseEnrollmentStatus(courseId: RecordIdentifier) {
        return API.apiClient.get(`/user/course/${courseId}/enrollment/status`);
    },
    getCourseEnrollmentIntent(courseId: RecordIdentifier, includeCourse = false) {
        return API.apiClient.get(`/user/course/${courseId}/enrollment` + (includeCourse ? '?include-course' : ''));
    },
    enrollCourse(courseId: RecordIdentifier, idempotent = false) {
        return API.apiClient.post(`/user/course/${courseId}/enrollment` + (idempotent ? '?idempotent' : ''));
    },
    withdrawCourse(courseId: RecordIdentifier) {
        return API.apiClient.delete(`/user/course/${courseId}/enrollment`);
    },
    joinCourseWaitlist(courseId: RecordIdentifier) {
        return API.apiClient.post(`/user/course/${courseId}/enrollment/waitlist`);
    },
    leaveCourseWaitlist(courseId: RecordIdentifier) {
        return API.apiClient.delete(`/user/course/${courseId}/enrollment/waitlist`);
    },

    buildCourseProduct(params: CourseProductCreationParameter) : CourseProduct {
        return {
            ...params,
            type: 2,
            type_human: 'Geschlossener Kurs',
            voucherable: false,
        };
    },
}
